<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/data
div
    ib-row
        ib-col(class="insetx-16")
            ib-button(
                class="fw-400 white filters fs6 menu-body",
                @click="hideFilters"
            )
                span(class="icons insetx-8")
                    +icon-data-filter
                span {{ $t('filters') }}
            div(v-show="filterButtons || $media.l")
                ib-button(
                    @click="showRegionOptions",
                    class="fw-400 dark-grey-text fs6 menu-body"
                ) {{ $t('regions') }}
                DropdownSelect(name="assets", :items="assets" :title="this.$t('asset_class')", @apply="apply" red, showActive)
                DropdownSelect(name="sectors", :items="sectors", :title="this.$t('sector')", @apply="apply")
                DropdownSelect(name="marketCap", :items="marketCaps" :title="this.$t('market_cap')", @apply="apply", :disabled="disableMarketCap")
                // We use a different component for currency because the styling & # options are different enough to justify it
                DropdownSelectCurrency(:items="currencies", @apply="apply")
            ib-button(@click="startOver", class="dark-grey-text fw-400 fs6 menu-body start-over") {{ $t('start_over') }}
    RegionSelection(ref="regionSelection", @apply="apply")
</template>

<script>
import { mapState, mapActions} from 'vuex';

import DropdownSelect from './DropdownSelect.vue';
import DropdownSelectCurrency from './DropdownSelectCurrency.vue';
import RegionSelection from './RegionSelection.vue';

export default {
    name: 'FilterOptions',
    components: {
        DropdownSelect,
        DropdownSelectCurrency,
        RegionSelection,
    },
    data() {
        return {
        }
    },
    methods: {
        showRegionOptions() {
            this.$refs.regionSelection.open(this.regions);
        },
        apply(name, data) {
            console.debug({name});
            console.debug(this.ids);

            switch(name) {
                case 'regions':
                    this.setRegions(data);
                    break;
                case 'sectors':
                    this.setSectors(data);
                    break;
                case 'marketCap':
                    this.setMarketCaps(data);
                    break;
                case 'assets':
                    this.setAssets(data);
                    break;
                case 'currency':
                    this.setSelectedCurrency(data);
                    if (this.ids.length > 0) {
                        console.debug('Ids...')
                        this.searchIds();
                        return;
                    }

                    break;
                default:
                    console.error('Unhandled menu dropdown apply', {name}, {data});
                    return;
            }
            this.setCurrentPage(1);
            this.setIds([]);
            this.search({'skipAvg:': false})
            .catch(error => {
                $alert(this.$t('zero_results'), {tone: 'remove'});
            });
        },
        startOver() {
            this.reset();
        },
        ...mapActions(['setSectors', 'setMarketCaps', 'setAssets', 'setStatus', 'setSelectedCurrency', 'setRegions', 'reset', 'hideFilters', 'search', 'setCurrentPage', 'setIds', 'searchIds'])
    },
    computed: {
        disableMarketCap: function() {
            const selectedAssets = this.$store.getters.selectedAssets;
            return selectedAssets.length === 1 && selectedAssets[0] === 'etfs';
        },
        ...mapState(['sectors', 'marketCaps', 'assets', 'currencies', 'regions', 'filterButtons', 'ids']),
    },
}
</script>

<style scoped lang="less">
    .start-over {
        @media (min-width: 768px) {
            float: right;
            top: -39px;
        }
    }
    .mt-24 {
        margin-top: 24px;
    }
</style>